export default __webpack_public_path__ + "static/media/marshmello-1.fa9e99a3.png";